export default __webpack_public_path__ + "static/arthur-dc7b16c510f2516e4f76da3bd30f2f84.jpg";